import { Roles } from "../../../../../constants/roles";
import { FormBase } from "../../../../../util/form-base-form";

export interface ReviewConfigEditorElements {
    reviewSettingsModalEl: HTMLElement | null;
    reviewSettingsWindowEl: HTMLElement | null;
    reviewSettingsTitleEl: HTMLElement | null;
    reviewSettingsPanelEl: HTMLElement | null;
    reviewSettingsSaveBtnEl: HTMLElement | null;
    reviewSettingsAddBtnEl: HTMLElement | null;
    reviewSettingsCloseBtnEls: HTMLElement[];
}

export class ReviewConfigEditorForm extends FormBase {
    public modalEl: HTMLElement;

    /**
     * @param {HTMLElement} modalEl
     */
    public constructor(modalEl: HTMLElement) {
        super();
        this.modalEl = modalEl;
    }

    public getElements(): ReviewConfigEditorElements {
        const reviewSettingsModalEl = this.queryElement(this.modalEl, '[data-action="review-settings-modal"]');
        const reviewSettingsWindowEl = this.getReviewSettingsWindow(this.modalEl);
        const reviewSettingsTitleEl = this.queryElement(this.modalEl, '[data-action="review-settings-title"]');
        const reviewSettingsPanelEl = this.queryElement(this.modalEl, '[data-action="review-settings-panel"]');
        const reviewSettingsSaveBtnEl = this.queryElement(this.modalEl, '[data-action="review-settings-save"]');
        const reviewSettingsAddBtnEl = this.queryElement(this.modalEl, '[data-action="review-settings-add"]');
        const reviewSettingsCloseBtnEls = this.getReviewSettingsCloseButtons();

        return {
            reviewSettingsModalEl,
            reviewSettingsWindowEl,
            reviewSettingsTitleEl,
            reviewSettingsPanelEl,
            reviewSettingsSaveBtnEl,
            reviewSettingsAddBtnEl,
            reviewSettingsCloseBtnEls,
        };
    }

    public getReviewSettingsWindow(root: ParentNode): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role~="${Roles.CATEGORY_REVIEW_EDITOR_REVIEW_SETTINGS_WINDOW}"]`,
            HTMLElement,
        );
    }

    public getReviewSettingsCloseButtons(): HTMLElement[] {
        return this.queryElements(this.modalEl, '[data-action="review-settings-close"]', HTMLElement);
    }

    public getTableWrap(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, ".category-review-editor__table-wrap", HTMLElement);
    }

    public getQuestionTextThInput(root: ParentNode, questionId: number): HTMLInputElement | null {
        return this.getInput(root, `[data-field="question_text_th"][data-question-id="${questionId}"]`);
    }

    public getQuestionControl(root: ParentNode, questionId: number): HTMLElement | null {
        return this.queryElement(root, `[data-question-id="${questionId}"]`, HTMLElement);
    }
}
